import { Button, Menu, MenuItem } from "@mui/material";
import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded";
import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { selectContract } from "../../actions/portal_actions";
import { LoadingProgress } from "../Common/LoadingProgress";

export const ContractSwitcherMenu = ({ onChange = () => {} }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useDispatch();
  const portaldetails = useSelector((state) => state.portaldetails);

  if (!portaldetails || !portaldetails.orgcontracts) {
    return <LoadingProgress text="Loading Contracts..." />;
  }

  const {
    user: { role, contracts: userContracts = [] },
    contracts = [],
    orgcontracts: organizationContracts = []
  } = portaldetails;

  const availableUserContracts =
    role === "keyworker" ? userContracts : contracts;

  const contractOptions = availableUserContracts.map(keyworkerContractId => ({
    label: portaldetails.orgcontracts.find(
      ({ contractID }) => contractID === keyworkerContractId
    ).name,
    value: keyworkerContractId
  }));

  let currentContract = "Select Contract";
  if (portaldetails.selectedContract && portaldetails.selectedContract.contractID){
     currentContract = portaldetails.selectedContract
      ? contractOptions.find(
          ({ value }) => value === portaldetails.selectedContract.contractID
        ).label
      : "Select Contract";
  }

  return (
    <>
      <Button
        disabled={availableUserContracts.length <= 0}
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={({ currentTarget }) => setAnchorEl(currentTarget)}
        style={{ textTransform: "none" }}
      >
        {currentContract}
        <ArrowDropDownRoundedIcon />
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        {contractOptions.map(({ label, value }) => (
          <MenuItem
            key={value}
            onClick={() => {
              dispatch(selectContract(
                organizationContracts.find(
                  ({ contractID }) => contractID === value
                )
              ));
              onChange(value);
              setAnchorEl(null);
            }}
          >
            {label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
